var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStreamLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20.5,
    r: 20,
    fill: "#C6FFB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8223 19.6084L20.5008 22.287M20.5008 22.287V32.1084M20.5008 22.287L23.1794 19.6084",
    stroke: "#008D0E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5011 28.5354C23.1059 28.5354 25.604 27.5007 27.4459 25.6588C29.2878 23.8169 30.3225 21.3188 30.3225 18.714C30.3225 16.1092 29.2878 13.6111 27.4459 11.7692C25.604 9.92733 23.1059 8.89258 20.5011 8.89258C17.8963 8.89258 15.3982 9.92733 13.5563 11.7692C11.7144 13.6111 10.6797 16.1092 10.6797 18.714C10.6797 21.3188 11.7144 23.8169 13.5563 25.6588C15.3982 27.5007 17.8963 28.5354 20.5011 28.5354Z",
    stroke: "#008D0E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamLine);
export default __webpack_public_path__ + "static/media/stream_line.95d92a1705eb8fabf7b93ddb1df2a8a5.svg";
export { ForwardRef as ReactComponent };